import { useRef } from 'react';

import { useQuery } from '@tanstack/react-query';

import { TCommentType } from '@entities/comment/model/types';
import { commentsApi } from '@widgets/Comments/api';
import { getCommentsPollingRoute } from '@widgets/Comments/api/routes';

export const useGetUnreadCommentsPolling = ({
    estimateId,
    isCommentsOpen,
    closedIntervalMs,
    commentType,
}: {
    estimateId: string;
    isCommentsOpen: boolean;
    closedIntervalMs: number;
    commentType: TCommentType;
}) => {
    const initializedPollingUrlsRef = useRef<Set<string>>(new Set());
    const currentPollingUrl = getCommentsPollingRoute({ estimateId, commentType });
    const isFirstRequestForCurrentApi = !initializedPollingUrlsRef.current.has(currentPollingUrl);

    if (isFirstRequestForCurrentApi) {
        initializedPollingUrlsRef.current.add(currentPollingUrl);
    }

    return useQuery<Record<string, unknown>, Error, string[]>({
        ...commentsApi.getUnreadCommentsPollingQueryOptions({
            estimateId,
            withIgnoreCache: isFirstRequestForCurrentApi,
            commentType,
        }),
        refetchInterval: isCommentsOpen ? false : closedIntervalMs,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: false,
    });
};
